import React from 'react';
import { renderToString } from 'react-dom/server';
import { Wrapper, LineChart, BarChart, Footer, ProfileSlider, ContentSlider } from '../../components';
import { Tabs, Accordion } from '../../components/Bootstrap';

const todayTab = (
    <ul className="list-group list-group-flush">
      <button type="button" className="list-group-item list-group-item-action d-flex justify-content-between align-items-center py-1 my-2 border-top-0 border-bottom-0 border-left border-primary">
        Adjust alignment of responsive content
        <span className="badge badge-primary badge-pill">4</span>
      </button>
      <button type="button" className="list-group-item list-group-item-action d-flex justify-content-between align-items-center py-1 my-2 border-top-0 border-bottom-0 border-left border-danger">
        Refactor classes to utilize normalizer
        <span className="badge badge-danger badge-pill">2</span>
      </button>
      <button type="button" className="list-group-item list-group-item-action d-flex justify-content-between align-items-center py-1 my-2 border-top-0 border-bottom-0 border-left border-warning">
        Rebuild store cluster on ADN4 secure sector
        <span className="badge badge-warning badge-pill">1</span>
      </button>
    </ul>);
    
const weekTab = (
    <Accordion itemClasses="card border-0" itemHeaderClasses="card-header border-bottom py-1 px-2" itemBodyClasses="card-body py-1 px-2" items={[
        {label:"10/23", link:"item_1", content:"Meeting with staff at 1:00."},
        {label:"10/24", link:"item_2", content:"Deadline for testing."},
        {label:"10/25", link:"item_3", content:"Vacation all day."},
    ]} />);

const monthTab = (
    <div>
        <ul className="list-group list-group-horizontal-md mb-3">
          <li className="list-group-item list-group-item-action">JAN</li>
          <li className="list-group-item list-group-item-action">FEB</li>
          <li className="list-group-item list-group-item-action">MAR</li>
          <li className="list-group-item list-group-item-action">APR</li>
          <li className="w-100"></li>
          <li className="list-group-item list-group-item-action">MAY</li>
          <li className="list-group-item list-group-item-action">JUN</li>
          <li className="list-group-item list-group-item-action">JUL</li>
          <li className="list-group-item list-group-item-action">AUG</li>
        </ul>
        <input className="form-control form-control-lg" placeholder="Enter status" />
    </div>
    );

class Dashboard extends React.Component{
    
    constructor(props) {
        super(props);
        this.state = {
            lineChartData:  {
              labels: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "June",
                "July",
                "Aug",
                "Sep",
                "Oct"
              ],
              datasets: [
                {
                  label: "Total",
                  data: [
                    125,
                    105,
                    145,
                    125,
                    165,
                    145,
                    185,
                    165,
                    205,
                    185
                    
                  ]
                },
                {
                  label: "Outsourced",
                  data: []
                },
                {
                  label: "Inside",
                  data: [
                    220,
                    210,
                    240,
                    230,
                    260,
                    250,
                    280,
                    270,
                    300,
                    290
                  ]
                }]
            },
            profiles: [
                {name:"Mark Diplacido", username:"diplacido", short:"Service Manager", pic:"assets/profile_4.png", likes:13, friends:3, posts: 11},
                {name:"Henry Richards", username:"richart", short:"CTO", pic:"assets/profile_2.png", likes:42, friends:88, posts: 94},
                {name:"Seth Scott", username:"sscott", short:"Network Administrator", pic:"assets/profile_1.png", likes:83, friends:44, posts: 89},
                {name:"Austin Skelly", username:"austinskelly", short:"Project Manager", pic:"assets/profile_3.png", likes:6, friends:9, posts: 13}
            ],
            calendarTabs: [
                {label:"Today", link:"tab_today", content: this.renderHtml(todayTab)},
                {label:"Week", link:"tab_week", content: this.renderHtml(weekTab)},
                {label:"Month", link:"tab_month", content: this.renderHtml(monthTab)},
            ],
            recentTransactions: [
                {heading:"$389.00", content:"Jason Kelker, Newport RI", icon:"icon-paypal", url:"./"},
                {heading:"$219.00", content:"Katherine Windham, Westford MA", icon:"icon-credit-card", url:"./"},
                {heading:"$879.00", content:"Mark Kirby, Ashton VA", icon:"icon-paypal", url:"./"}
            ]
        };
    }
    
    renderHtml(comp) {
        return renderToString(comp);
    }
    
    render(){
        return (
            <Wrapper>
                <div className="flex-fill">
                    <div className="row mb-3 wow zoomIn">
                        <div className="col-xl col-sm-6 pb-3">
                            <div className="card d-block p-0 h-100 shadow-sm">
                                <div className="row h-100 no-gutters bg-white rounded flex-nowrap">
                                    <div className="col-auto bg-success rounded-left">&nbsp;</div>
                                    <div className="col p-3 py-4 text-success">
                                        <h6 className="text-truncate text-uppercase">Calls</h6>
                                        <h3 className="text-nowrap">210</h3>
                                    </div>
                                    <div className="col-auto d-flex text-success">
                                        <h1 className="mb-0 mx-auto align-self-center">
                                        <a href="/" className="nav-link text-success pb-0" title="View details"><span className="d-inline-block lnr lnr-phone"></span></a>
                                        </h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl col-sm-6 pb-3">
                            <div className="card d-block p-0 h-100 shadow-sm">
                                <div className="row h-100 no-gutters bg-white rounded flex-nowrap">
                                    <div className="col-auto bg-danger rounded-left">&nbsp;</div>
                                    <div className="col p-3 py-4 text-danger">
                                        <h6 className="text-truncate text-uppercase">Sales</h6>
                                        <h3>53</h3>
                                    </div>
                                    <div className="col-auto d-flex rounded-right">
                                        <h1 className="mb-0 mx-auto align-self-center"><a href="/" className="nav-link text-danger pb-0" title="View details">
                                            <span className="d-inline-block lnr lnr-cart"></span></a>
                                        </h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl col-sm-6 pb-3">
                            <div className="card d-block h-100 shadow-sm">
                                <div className="row h-100 no-gutters bg-white rounded flex-nowrap">
                                    <div className="col-auto bg-primary rounded-left">&nbsp;</div>
                                    <div className="col p-3 py-4 text-primary">
                                        <h6 className="text-truncate text-uppercase">Growth</h6>
                                        <h3 className="text-nowrap">19%</h3>
                                    </div>
                                    <div className="col-auto d-flex rounded-right">
                                        <h1 className="mb-0 mx-auto align-self-center">
                                            <a href="/" className="nav-link pb-0 text-primary" title="View details">
                                                <span className="d-inline-block lnr lnr-rocket"></span>
                                            </a>
                                        </h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl col-sm-6 pb-3">
                            <div className="card d-block p-0 h-100 shadow-sm">
                                <div className="row h-100 no-gutters bg-white rounded flex-nowrap">
                                    <div className="col-auto bg-info rounded-left">&nbsp;</div>
                                    <div className="col p-3 py-4 text-info">
                                        <h6 className="text-truncate text-uppercase">Alerts</h6>
                                        <h3>2</h3>
                                    </div>
                                    <div className="col-auto d-flex rounded-right">
                                        <h1 className="mb-0 mx-auto align-self-center">
                                            <a href="/" className="nav-link text-info pb-0" title="View details"><i className="lnr lnr-alarm"></i></a>
                                        </h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-xl-6 col-md-6 pb-3 wow zoomIn">
                            <div className="card h-100 shadow-sm">
                                <div className="card-body p-xl-3 p-2 d-flex flex-column">
                                    <h4 className="font-weight-light mb-3">Revenue</h4>
                                    <div className="my-auto p-1 py-2">
                                        <LineChart data={this.state.lineChartData} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-md-6 pb-3 wow zoomIn">
                            <div className="card h-100 shadow-sm">
                                <div className="card-body p-xl-3 p-2 d-flex flex-column">
                                    <h4 className="font-weight-light mb-3">Products</h4>
                                    <div className="my-auto p-1 py-2">
                                        <BarChart />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-6 py-3">
                            <Tabs className="card shadow-sm p-3 h-100" items={this.state.calendarTabs} />
                        </div>
                        <div className="col-xl-6 py-3">
                            <ProfileSlider className="h-100" carouselId="slider2" heading="Team" profiles={this.state.profiles} headerClasses="bg-transparent" contentClasses="text-left" countClasses="text-left" />
                        </div>
                        <div className="col-xl-6 py-3">
                            <ContentSlider className="h-100" headerClasses="bg-transparent" carouselButtonClasses="btn btn-light btn-sm ml-2" /> 
                        </div>
                        <div className="col-xl-6 py-3">
                            <ContentSlider className="h-100" 
                                carouselId="transactionSlider"
                                headerClasses="bg-transparent" 
                                carouselButtonClasses="btn btn-light btn-sm ml-2" 
                                carouselInterval="6000" 
                                textDetails="View Order"
                                heading="Recent Transactions"
                                items={this.state.recentTransactions} /> 
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl py-3">
                            <div className="card h-100 shadow-sm wow fadeInUp" data-wow-delay=".5s">
                                <div className="card-body">
                                    <div className="h4 font-weight-light m-0">
                                        <i className="float-right lnr lnr-gift"></i>
                                        Earnings
                                    </div>
                                    <div>up 15%</div>
                                    <div className="progress my-3">
                                        <div role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" className="progress-bar bg-primary w-75"></div>
                                    </div> <small className="text-muted"><a href="#modalSmall" data-toggle="modal">Updated 5 mins ago</a></small></div>
                            </div>
                        </div>
                        <div className="col-xl py-3">
                            <div className="card h-100 shadow-sm wow slideInUp">
                                <div className="card-body">
                                    <div className="h4 font-weight-light m-0">
                                        <i className="float-right lnr lnr-sync"></i>
                                        Pending
                                    </div>
                                    <div>Transfers in progress...</div>
                                    <div className="progress my-3">
                                        <div role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" className="progress-bar bg-dark w-25"></div>
                                    </div>
                                    <small className="text-muted">Estimated time remaining: 3.34 hrs</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </Wrapper>
        );
    }
}

export default Dashboard;
